import { addManualFlagToCase } from '../api/flags'
import type { Resolvers } from '../generated/server/resolvers'

const FlagResolver: Resolvers = {
  Mutation: {
    addManualFlagToCase: (_parent, { input }) => addManualFlagToCase(input?.case_id, input?.flag_type),
  },
}

export default FlagResolver
